export const FEED_SOURCE_OPTIONS = [
  { text: 'Intercard', value: 'INTERCARD' },
  { text: 'Intercard-MAS', value: 'INTERCARD_MAS' },
  { text: 'Intercard-BGP', value: 'INTERCARD_BGP' },
  { text: 'Intercard Impulse', value: 'INTERCARD_IMPULSE' },
  { text: 'Seedlive', value: 'SEEDLIVE' },
  { text: 'Nayax', value: 'NAYAX' },
  { text: 'Alipay', value: 'ALIPAY' },
  { text: 'WeChat', value: 'WECHAT' },
  { text: 'Cash (No Modem)', value: 'CASH_NO_MODEM' },
];

export const CREDIT_CASH_OPTIONS = [
  { text: 'No credit, Location manual Cash', value: 'NO_CREDIT_LOCATION_MANUAL_CASH' },
  { text: 'No credit, Venu manual Cash', value: 'NO_CREDIT_VENU_MANUAL_CASH' },
  { text: 'Venu Credit, No Cash', value: 'VENU_CREDIT_NO_CASH' },
  { text: 'Venu Credit, Venu digital Cash', value: 'VENU_CREDIT_VENU_DIGITAL_CASH' },
  { text: 'Venu Credit, Venu digital Cash and manual Cash', value: 'VENU_CREDIT_VENU_DIGITAL_AND_MANUAL_CASH' },
  { text: 'Location Credit, Location digital Cash', value: 'LOCATION_CREDIT_LOCATION_DIGITAL_CASH' },
  {
    text: 'Location Credit, Location digital Cash and manual Cash',
    value: 'LOCATION_CREDIT_LOCATION_DIGITAL_AND_MANUAL_CASH',
  },
  { text: 'Venu Credit, Location digital Cash', value: 'VENU_CREDIT_LOCATION_DIGITAL_CASH' },
  { text: 'Venu Credit, Manual Cash', value: 'VENU_CREDIT_MANUAL_CASH' },
];

/**
 * Get filtered credit/cash options based on Standalone (calculateRent) value
 * @param {boolean} isStandalone - Whether Standalone is enabled
 * @returns {Array} Filtered options array
 */
export const getCreditCashOptions = (isStandalone) => {
  if (isStandalone) {
    // If Standalone = YES - show only these 6 options
    return CREDIT_CASH_OPTIONS.filter(
      (option) =>
        option.value === 'NO_CREDIT_LOCATION_MANUAL_CASH' ||
        option.value === 'NO_CREDIT_VENU_MANUAL_CASH' ||
        option.value === 'VENU_CREDIT_NO_CASH' ||
        option.value === 'LOCATION_CREDIT_LOCATION_DIGITAL_CASH' ||
        option.value === 'LOCATION_CREDIT_LOCATION_DIGITAL_AND_MANUAL_CASH' ||
        option.value === 'VENU_CREDIT_LOCATION_DIGITAL_CASH',
    );
  } else {
    // If Standalone = NO - show only these 4 options
    return CREDIT_CASH_OPTIONS.filter(
      (option) =>
        option.value === 'NO_CREDIT_VENU_MANUAL_CASH' ||
        option.value === 'VENU_CREDIT_NO_CASH' ||
        option.value === 'VENU_CREDIT_VENU_DIGITAL_CASH' ||
        option.value === 'VENU_CREDIT_VENU_DIGITAL_AND_MANUAL_CASH' ||
        option.value === 'VENU_CREDIT_MANUAL_CASH',
    );
  }
};
